import { EServiceId } from './serviceId';
import { EServiceType } from './serviceType';

export interface IPublishTermsService {
  /** Идентификатор услуги */
  id: EServiceId;
  /** Название тарифа */
  name: string;
  /** Необходима идентификация пользователя */
  identificationRequired: boolean;
  /** Причина недоступности тарифа */
  unavailableReasonType: EUnavailableReason | null;
  /** Является дополнительным */
  isAdditional: boolean;
  /** Список несовместимых сервисов для текущего */
  incompatibleServices: Array<EServiceType>;
  /** Является тарифом по-умолчанию */
  isDefault: boolean;
  /** Доступна ли автопролонгация у тарифа */
  isAutoProlongAvailable: boolean;
  /** Количество доступных действий, сколько типов размещения можно купить */
  availableActionsCount: number;
  /** Типы услуги */
  services: Array<EServiceType>;
  /** Доступен ли тариф в данном случае */
  isAvailable: boolean;
  /** Уникальный ключ тарифа */
  key: string;
  /** Базовая ставка услуги */
  baseAuctionBet: number | null;
}

export enum EUnavailableReason {
  /** Заблокировано администрацией */
  deniedBySanctions = 'deniedBySanctions',
  /** Нет фотографий */
  noPhotos = 'noPhotos',
  /** Доступно после окончания периода публикации Премиум */
  onlyAfterPremiumServiceExpiration = 'onlyAfterPremiumServiceExpiration',
  /** Не является участником акции */
  onlyInAction = 'onlyInAction',
  /** Не выполнены условия, необходимые для размещения Топ-объявлений */
  top3ServiceDenied = 'top3ServiceDenied',
}
